// Angular
import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';
import { OnInit } from '@angular/core';

@Directive({
    selector: '[sortColumn]'
})

export class SortDirective implements OnInit {
    @Input() data: any[];
    @Input('sortKey') key: any;
    private toggleSort = false;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2) {
    }

    ngOnInit() {
        this.renderer.listen(this.el.nativeElement, 'click', (event) => {
            const parentNode = this.el.nativeElement.parentNode;
            let children = parentNode.children;

            if (this.data && this.key) {
                const sortedData: any = this.sortArray();
            }

            this.toggleSort = !this.toggleSort;
        });
    }

    sortArray(): Array<any> {
        const tempArray: Array<any> = this.data;

        tempArray.sort((a, b) => {
            const aKey = a[this.key];
            const bKey = b[this.key];
            const str1: string = typeof(aKey) === 'string' ? aKey.toLowerCase() : aKey;
            const str2: string = typeof(bKey) === 'string' ? bKey.toLowerCase() : bKey;

            if (this.toggleSort) {
                if (str1 < str2) {
                    return -1;
                }
                if (str1 > str2) {
                    return 1;
                }
            } else {
                if (str1 > str2) {
                    return -1;
                }
                if (str1 < str2) {
                    return 1;
                }
            }
            return 0;
        });

        return tempArray;
    }
}
